<app-button-group
    variant="outline"
    [color]="start() && end() ? 'primary' : 'gray'"
>
    <app-button
        variant="outline"
        [color]="start() && end() ? 'primary' : 'white'"
        [cdkMenuTriggerFor]="calendar"
    >
        @if (start() && end()) {
            <p class="text-sm">
                {{ start() | date: "y.MM.dd" }} - {{ end() | date: "y.MM.dd" }}
            </p>
        } @else {
            <p class="text-sm">{{ label() }}</p>
        }
    </app-button>
    @if (start() && end()) {
        <app-button (click)="handleReset()" variant="outline" color="gray">
            <p class="text-sm">초기화</p>
        </app-button>
    }
</app-button-group>

<ng-template #calendar>
    <section cdkMenu class="shadow-xl rounded-xl">
        <app-range-calendar [(start)]="start" [(end)]="end" />
        <div
            class="border-t p-4 bg-white flex w-full justify-between items-center gap-6"
        >
            <div class="flex gap-2 items-center">
                <p class="text-sm">
                    <span class="text-gray-400">시작일</span>
                    @if (start()) {
                        {{ start() | date: "y년 MM월 dd일" }}
                    }
                </p>
                <p class="text-gray-400">-</p>
                <p class="text-sm">
                    <span class="text-gray-400">종료일</span>
                    @if (end()) {
                        {{ end() | date: "y년 MM월 dd일" }}
                    }
                </p>
            </div>
            <div class="flex gap-3 items-center">
                <app-button (click)="close()" color="white" variant="outline"
                    >취소</app-button
                >
                <app-button (click)="confirm()">확인</app-button>
            </div>
        </div>
    </section>
</ng-template>
